// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.challenges-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}


.challenges-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.challenges-search {
  margin-bottom: 20px;
}

.challenges-search-input {
  width: 100%;
  max-width: 420px;
  padding: 10px 14px;
  border-radius: 10px;
  border: 1px solid #e2e8f0;
  font-size: 14px;
  color: #1f2937;
  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
}

.challenges-search-input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
}

.challenges-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.challenges-header h1 {
  font-size: 28px;
  margin: 0;
  color: #ffffff;
}

.btn-create-challenge {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
}

.btn-create-challenge.btn-create-friendly {
  background: linear-gradient(135deg, #10b981 0%, #0f766e 100%);
}

.btn-create-challenge:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4);
}

/* Section headers */
.pending-direct-challenges,
.open-challenges {
  margin-bottom: 40px;
    width: 100%;
  max-width: 800px;
  margin: 0 auto;
}

.pending-direct-challenges h2,
.open-challenges h2 {
  font-size: 20px;
  margin: 0 0 20px 0;
  color: #ffffff;
  padding-bottom: 10px;
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
}

.pending-direct-challenges h2 {
  color: #ffffff;
  border-bottom-color: rgba(255, 255, 255, 0.2);
}

.challenges-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 20px;
}

.challenges-list {
  display: grid;
  gap: 12px;
  
}

.challenge-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  column-gap: 16px;
  row-gap: 8px;
  padding: 9px 12px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.55);
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
}

.challenge-row-main {
  display: grid;
  gap: 4px;
  flex: 1 1;
  min-width: 0;
  padding-right: 8px;
}

.challenge-row-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 900;
  color: #ffffff;
  font-size: 16px;
  flex-wrap: wrap;
}

.challenge-game-prefix {
  background: rgba(255, 255, 255, 0.2);
  color: #ffffff;
  font-size: 11px;
  font-weight: 800;
  border-radius: 999px;
  padding: 2px 8px;
}

.challenge-status-inline {
  font-size: 12px;
  font-weight: 700;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  padding: 2px 8px;
}

.challenge-ai-badge {
  font-size: 11px;
  font-weight: 900;
  color: #fde68a;
  background: rgba(245, 158, 11, 0.2);
  border: 1px solid rgba(245, 158, 11, 0.35);
  border-radius: 999px;
  padding: 2px 8px;
}

.challenge-row-meta {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
  font-size: 13px;
  color: #ffffff;
  font-weight: 700;
}

.challenge-row-meta span {
  color: #ffffff;
}

.challenge-mode {
  font-size: 12px;
  font-weight: 900;
  padding: 4px 10px;
  border-radius: 999px;
}

.challenge-mode.betting {
  background: rgba(239, 68, 68, 0.2);
  color: #fca5a5;
}

.challenge-mode.friendly {
  background: rgba(34, 197, 94, 0.2);
  color: #86efac;
}

.challenge-wager.betting {
  color: #fca5a5;
  font-weight: 900;
}

.challenge-wager.friendly {
  color: #86efac;
  font-weight: 900;
}

.challenge-row-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  justify-self: end;
}

.challenge-row-actions .btn-accept,
.challenge-row-actions .btn-reject {
  width: auto;
  margin: 0;
  white-space: nowrap;
}

@media (max-width: 760px) {
  .challenge-row {
    grid-template-columns: 1fr;
    align-items: stretch;
  }

  .challenge-row-actions {
    width: 100%;
    justify-content: flex-end;
    flex-wrap: wrap;
  }
}

.challenge-card {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  border: 2px solid transparent;
}

.challenge-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  border-color: #667eea;
}

.challenge-card.direct-challenge {
  border-color: #ffe0e0;
  background: #fffbfb;
}

.challenge-card.direct-challenge:hover {
  border-color: #e74c3c;
  box-shadow: 0 8px 24px rgba(231, 76, 60, 0.2);
}

.challenge-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.challenge-header h3 {
  margin: 0;
  color: #333;
  font-size: 18px;
}

.challenge-id {
  background: rgba(255, 255, 255, 0.18);
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  color: #ffffff;
  font-weight: 700;
}

.challenge-details {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 8px;
  margin-bottom: 15px;
}

.detail {
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
  font-size: 14px;
}

.detail:last-child {
  margin-bottom: 0;
}

.detail label {
  color: #666;
  font-weight: 500;
}

.detail span {
  color: #333;
  font-weight: 600;
}

.detail .amount {
  color: #667eea;
  font-size: 16px;
}

.detail .amount.risk {
  color: #e74c3c;
}

.challenge-stats {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
}

.stat {
  flex: 1 1;
  background: #f0f0f0;
  padding: 10px;
  border-radius: 8px;
  text-align: center;
}

.stat .label {
  display: block;
  font-size: 12px;
  color: #666;
  margin-bottom: 5px;
  font-weight: 500;
}

.stat .value {
  display: block;
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

/* Challenge actions for direct challenges */
.challenge-actions {
  display: flex;
  gap: 10px;
}

.challenge-actions .btn-accept,
.challenge-actions .btn-reject {
  flex: 1 1;
}

.btn-accept {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-accept:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);
}

.btn-accept:active {
  transform: translateY(0);
}

.btn-reject {
  background: #f5f5f5;
  color: #e74c3c;
  border: 2px solid #e74c3c;
  padding: 10px;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  font-size: 14px;
}

.btn-reject:hover {
  background: #fee;
  transform: translateY(-2px);
  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.3);
}

.btn-reject:active {
  transform: translateY(0);
}

.no-challenges {
  text-align: center;
  padding: 60px 20px;
  background: rgba(15, 23, 42, 0.45);
  border-radius: 12px;
  margin: 40px 0;
}

.no-challenges p {
  margin: 10px 0;
  color: #ffffff;
  font-size: 16px;
}

.no-challenges p:first-child {
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px 15px;
  border-radius: 8px;
  margin-bottom: 20px;
  font-size: 14px;
}


`, "",{"version":3,"sources":["webpack://./src/styles/Challenges.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;;AAGA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA,oBAAoB;AACpB;;EAEE,mBAAmB;IACjB,WAAW;EACb,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;;AAEX;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,eAAe;EACjB;AACF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;EACxC,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,SAAO;AACT;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,6CAA6C;AAC/C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;AACjB","sourcesContent":[".challenges-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 20px;\n}\n\n\n.challenges-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 30px;\n}\n\n.challenges-search {\n  margin-bottom: 20px;\n}\n\n.challenges-search-input {\n  width: 100%;\n  max-width: 420px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  border: 1px solid #e2e8f0;\n  font-size: 14px;\n  color: #1f2937;\n  box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);\n}\n\n.challenges-search-input:focus {\n  outline: none;\n  border-color: #667eea;\n  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);\n}\n\n.challenges-actions {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n}\n\n.challenges-header h1 {\n  font-size: 28px;\n  margin: 0;\n  color: #ffffff;\n}\n\n.btn-create-challenge {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.btn-create-challenge.btn-create-friendly {\n  background: linear-gradient(135deg, #10b981 0%, #0f766e 100%);\n}\n\n.btn-create-challenge:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 16px rgba(102, 126, 234, 0.4);\n}\n\n/* Section headers */\n.pending-direct-challenges,\n.open-challenges {\n  margin-bottom: 40px;\n    width: 100%;\n  max-width: 800px;\n  margin: 0 auto;\n}\n\n.pending-direct-challenges h2,\n.open-challenges h2 {\n  font-size: 20px;\n  margin: 0 0 20px 0;\n  color: #ffffff;\n  padding-bottom: 10px;\n  border-bottom: 2px solid rgba(255, 255, 255, 0.2);\n}\n\n.pending-direct-challenges h2 {\n  color: #ffffff;\n  border-bottom-color: rgba(255, 255, 255, 0.2);\n}\n\n.challenges-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 20px;\n}\n\n.challenges-list {\n  display: grid;\n  gap: 12px;\n  \n}\n\n.challenge-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  align-items: center;\n  column-gap: 16px;\n  row-gap: 8px;\n  padding: 9px 12px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.55);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);\n}\n\n.challenge-row-main {\n  display: grid;\n  gap: 4px;\n  flex: 1;\n  min-width: 0;\n  padding-right: 8px;\n}\n\n.challenge-row-title {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-weight: 900;\n  color: #ffffff;\n  font-size: 16px;\n  flex-wrap: wrap;\n}\n\n.challenge-game-prefix {\n  background: rgba(255, 255, 255, 0.2);\n  color: #ffffff;\n  font-size: 11px;\n  font-weight: 800;\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.challenge-status-inline {\n  font-size: 12px;\n  font-weight: 700;\n  color: #e2e8f0;\n  background: rgba(255, 255, 255, 0.12);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.challenge-ai-badge {\n  font-size: 11px;\n  font-weight: 900;\n  color: #fde68a;\n  background: rgba(245, 158, 11, 0.2);\n  border: 1px solid rgba(245, 158, 11, 0.35);\n  border-radius: 999px;\n  padding: 2px 8px;\n}\n\n.challenge-row-meta {\n  display: flex;\n  gap: 12px;\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.challenge-row-meta span {\n  color: #ffffff;\n}\n\n.challenge-mode {\n  font-size: 12px;\n  font-weight: 900;\n  padding: 4px 10px;\n  border-radius: 999px;\n}\n\n.challenge-mode.betting {\n  background: rgba(239, 68, 68, 0.2);\n  color: #fca5a5;\n}\n\n.challenge-mode.friendly {\n  background: rgba(34, 197, 94, 0.2);\n  color: #86efac;\n}\n\n.challenge-wager.betting {\n  color: #fca5a5;\n  font-weight: 900;\n}\n\n.challenge-wager.friendly {\n  color: #86efac;\n  font-weight: 900;\n}\n\n.challenge-row-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n  justify-self: end;\n}\n\n.challenge-row-actions .btn-accept,\n.challenge-row-actions .btn-reject {\n  width: auto;\n  margin: 0;\n  white-space: nowrap;\n}\n\n@media (max-width: 760px) {\n  .challenge-row {\n    grid-template-columns: 1fr;\n    align-items: stretch;\n  }\n\n  .challenge-row-actions {\n    width: 100%;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n  }\n}\n\n.challenge-card {\n  background: white;\n  border-radius: 12px;\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n  border: 2px solid transparent;\n}\n\n.challenge-card:hover {\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);\n  border-color: #667eea;\n}\n\n.challenge-card.direct-challenge {\n  border-color: #ffe0e0;\n  background: #fffbfb;\n}\n\n.challenge-card.direct-challenge:hover {\n  border-color: #e74c3c;\n  box-shadow: 0 8px 24px rgba(231, 76, 60, 0.2);\n}\n\n.challenge-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 15px;\n}\n\n.challenge-header h3 {\n  margin: 0;\n  color: #333;\n  font-size: 18px;\n}\n\n.challenge-id {\n  background: rgba(255, 255, 255, 0.18);\n  padding: 4px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  color: #ffffff;\n  font-weight: 700;\n}\n\n.challenge-details {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 8px;\n  margin-bottom: 15px;\n}\n\n.detail {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 10px;\n  font-size: 14px;\n}\n\n.detail:last-child {\n  margin-bottom: 0;\n}\n\n.detail label {\n  color: #666;\n  font-weight: 500;\n}\n\n.detail span {\n  color: #333;\n  font-weight: 600;\n}\n\n.detail .amount {\n  color: #667eea;\n  font-size: 16px;\n}\n\n.detail .amount.risk {\n  color: #e74c3c;\n}\n\n.challenge-stats {\n  display: flex;\n  gap: 15px;\n  margin-bottom: 15px;\n}\n\n.stat {\n  flex: 1;\n  background: #f0f0f0;\n  padding: 10px;\n  border-radius: 8px;\n  text-align: center;\n}\n\n.stat .label {\n  display: block;\n  font-size: 12px;\n  color: #666;\n  margin-bottom: 5px;\n  font-weight: 500;\n}\n\n.stat .value {\n  display: block;\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n}\n\n/* Challenge actions for direct challenges */\n.challenge-actions {\n  display: flex;\n  gap: 10px;\n}\n\n.challenge-actions .btn-accept,\n.challenge-actions .btn-reject {\n  flex: 1;\n}\n\n.btn-accept {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.btn-accept:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(102, 126, 234, 0.3);\n}\n\n.btn-accept:active {\n  transform: translateY(0);\n}\n\n.btn-reject {\n  background: #f5f5f5;\n  color: #e74c3c;\n  border: 2px solid #e74c3c;\n  padding: 10px;\n  border-radius: 8px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-size: 14px;\n}\n\n.btn-reject:hover {\n  background: #fee;\n  transform: translateY(-2px);\n  box-shadow: 0 6px 12px rgba(231, 76, 60, 0.3);\n}\n\n.btn-reject:active {\n  transform: translateY(0);\n}\n\n.no-challenges {\n  text-align: center;\n  padding: 60px 20px;\n  background: rgba(15, 23, 42, 0.45);\n  border-radius: 12px;\n  margin: 40px 0;\n}\n\n.no-challenges p {\n  margin: 10px 0;\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.no-challenges p:first-child {\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.error-message {\n  background: #fee;\n  border: 1px solid #fcc;\n  color: #c33;\n  padding: 12px 15px;\n  border-radius: 8px;\n  margin-bottom: 20px;\n  font-size: 14px;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
